import LoginPage from "views/pages/LoginPage.jsx";
import PageTest2 from "views/pagesNoLayout/PageTest2.jsx";
// @material-ui/icons

//forLogin:true จำเป็นต้องล็อกอินแล้ว , forGuest:true ต้องไม่ล็อกอินอยู่, ถ้าไม่ใส่สองตัวนี้คือเข้าได้หมด
const rootPath = "/pages"
const pagesRoutes = [
  {
    forGuest: true,
    path: rootPath + "/login",
    component: LoginPage
  },
  {
    // forGuest: true,
    path: rootPath + "/pt2",
    component: PageTest2
  },
  {
    //สำหรับ path ไม่ตรงเลยให้ย้ายไปหน้า page404
    redirect: true,
    path: rootPath,
    pathTo: "/page404"
  }
];

export default pagesRoutes;
